import React from "react";
import {
  LoginBoxContainer,
  LoginBoxContent,
  LoginBoxFooter,
} from "./styles";
import DefaultButton from "../../../../shared/util/DefaultButton";
import { useNavigate } from "react-router-dom";
import AuthProvider from "../../../../shared/provider/AuthProvider";

interface LoginBoxProps {
  className?: string;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setUserNotFound: React.Dispatch<React.SetStateAction<boolean>>;
}

function LoginBox({ className, open, setOpen, setUserNotFound }: LoginBoxProps): JSX.Element {
  React.useEffect(() => {
    if (!open) setUserNotFound(false);
  }, [open]);

  React.useEffect(() => {
    if (open) {
      window.localStorage.removeItem("tenantName");
    }
  }, [open]);

  function handleGov() {
    try {
      const mode = window.global.env.startMode;
      if (mode === 'GOVBR_MODE') {
        window.location.href = window.global.env.reactAppOauthLoginUrl;
      } else if (mode === 'KEYCLOAK_MODE') {
        window.location.href = window.global.env.reactAppKeycloakLoginUrl || window.global.env.reactAppOauthLoginUrl;
      } else {
        // LEGACY_MODE é o modo padrão (inclui START_MODE=LEGACY_MODE ou qualquer valor inesperado)
        setOpen(true);
      }
    } catch (error) {
      console.log({error})
    }
  }

  return (
    <LoginBoxContainer className={className}>
      <LoginBoxContent>
        <h3>
          Já faz parte da nossa comunidade?
        </h3>

        <p><b>Entre e cadastre uma ideia!</b></p>

        <DefaultButton
        width="250px"
        marginTop="12px"
          params={{
            onClick: () => handleGov(),
          }}
        >
          <span>Entrar com o <span style={{fontWeight: 800}}>gov.br</span></span>
        </DefaultButton>
      </LoginBoxContent>

      <LoginBoxFooter>
      </LoginBoxFooter>
    </LoginBoxContainer>
  );
}

export default LoginBox;
